import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "Research Focused",
  "Premium Presentation",
  "Trusted Quality",
  "Analytical Precision",
  "Discreet Shipping",
];

export default function BrandMarquee() {
  return (
    <div className="py-10 border-y border-[#1E2A44]/10 bg-[#F7F4EF] overflow-hidden" aria-hidden="true">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={i} className="mx-10 inline-flex items-center gap-10">
            <span className="font-serif text-4xl md:text-6xl text-[#1E2A44]/85 tracking-tight">
              {w}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#C8A96A]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
